// process.env.NODE_ENV is set automatically by react-scripts (build = "production",
// start = "development") — never read from .env, so this can't be misconfigured.
const DEV_API_PATH = "http://kirtan.pcb.click";
// const DEV_API_PATH = "http://localhost:5200";

export const environment = {
  production: process.env.NODE_ENV === "production",
  API_PATH: DEV_API_PATH,
};

if (environment.production) {
  // The API server serves this build itself in production — always same origin.
  environment.API_PATH = window.location.origin;
}
